// Token management utility for API authentication (dynamic via authService)
import { getToken as getStoredToken, getAuthInfo } from '../services/authService';

// Parse JWT token to get user information
const parseJwt = (token) => {
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
    return JSON.parse(jsonPayload);
  } catch (error) {
    console.error('Error parsing JWT token:', error);
    return {};
  }
};

// Get the current token (from storage)
export const getToken = () => getStoredToken();

// Get user information from token
export const getUserInfo = () => {
  const token = getStoredToken();
  if (!token) return {};
  const decodedToken = parseJwt(token);
  // Derive userNo from a wider set of possible claim names
  const userNo = (
    decodedToken.UserNo ||
    decodedToken.userNo ||
    decodedToken.user_no ||
    decodedToken.MemberNo ||
    decodedToken.memberNo ||
    decodedToken.member_no ||
    decodedToken.EmpNo ||
    decodedToken.employeeNo ||
    decodedToken.EmployeeNo ||
    decodedToken.LoginUserNo ||
    ''
  );
  // Derive companyNo from token first; fallback to authService custNo when absent
  let companyNo = (
    decodedToken.CompanyNo ||
    decodedToken.companyNo ||
    decodedToken.company_no ||
    decodedToken.SupplierNo ||
    decodedToken.supplierNo ||
    ''
  );
  if (!companyNo) {
    try {
      const { custNo } = getAuthInfo() || {};
      if (custNo) companyNo = custNo;
    } catch (_) {}
  }
  return {
    email: decodedToken.unique_name || decodedToken.email || '',
    userNo,
    companyNo,
    memberNo: decodedToken.MemberNo || decodedToken.memberNo || decodedToken.member_no || ''
  };
};

// Get authorization header for API requests
export const getAuthHeader = () => ({
  Authorization: `Bearer ${getStoredToken()}`
});
